/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OneTimeAccessTokenActivity
 */
export interface OneTimeAccessTokenActivity {
    /**
     * 
     * @type {number}
     * @memberof OneTimeAccessTokenActivity
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof OneTimeAccessTokenActivity
     */
    readonly date: Date;
    /**
     * 
     * @type {string}
     * @memberof OneTimeAccessTokenActivity
     */
    ip: string;
    /**
     * 
     * @type {number}
     * @memberof OneTimeAccessTokenActivity
     */
    token: number;
}

export function OneTimeAccessTokenActivityFromJSON(json: any): OneTimeAccessTokenActivity {
    return OneTimeAccessTokenActivityFromJSONTyped(json, false);
}

export function OneTimeAccessTokenActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneTimeAccessTokenActivity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'ip': json['ip'],
        'token': json['token'],
    };
}

export function OneTimeAccessTokenActivityToJSON(value?: OneTimeAccessTokenActivity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ip': value.ip,
        'token': value.token,
    };
}


